import React from 'react';
import PropTypes from 'prop-types';

function initialsOf(firstName, lastName) {
  const first = (firstName ?? '').trim().charAt(0);
  const last = (lastName ?? '').trim().charAt(0);
  return `${first}${last}`.toUpperCase();
}

/**
 * initials badge standing in for an agent's photo, which the roster does not carry
 * @param firstName - agent's first name
 * @param lastName - agent's last name
 */
export default function AgentAvatar({ firstName, lastName }) {
  return (
    <span
      aria-hidden
      className='inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-grey-lighter text-xs font-medium text-black'
    >
      {initialsOf(firstName, lastName)}
    </span>
  );
}

AgentAvatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string
};
